import type { ReactNode } from 'react';
import { ImpersonationBanner } from '~/features/market/impersonation/ImpersonationBanner';

/**
 * [MCV-1752] The signed-in shell is one viewport-high column so the document never scrolls (Layout's
 * column does). The impersonation banner is its first row in normal flow and the brand shell takes
 * the rest. The banner used to be fixed with a 60px body margin, which gave the document a 60px
 * scroll range that slid the top bar up under it. Controls that are fixed against the top bar add
 * var(--impersonation-banner-height,0px) to their offset.
 */
export const SignedInShell = ({ children }: { children: ReactNode }) => (
  <div className="flex flex-col h-screen">
    <ImpersonationBanner />
    <div className="flex-1 min-h-0">{children}</div>
  </div>
);
